var axios = require('axios');

const createPostit = (worldId, data, onSuccess, onError) => {
  const config = {
    method: 'post',
    url: '/postit/create',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    data: {
      world_id: Number(worldId),
      data: data,
      scene_id: data.scene_id,
    },
  };

  axios(config)
    .then(function (response) {
      onSuccess && onSuccess(response);
    })
    .catch(function (error) {
      console.log(error);
      onError && onError(error);
    });
};

const updatePostit = (postitId, data, onSuccess, onError) => {
  const config = {
    method: 'post',
    url: `/postit/update/${Number(postitId)}`,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    data: {
      data: data,
    },
  };

  axios(config)
    .then(function (response) {
      onSuccess && onSuccess(response);
    })
    .catch(function (error) {
      console.log(error);
      onError && onError(error);
    });
};

const deletePostit = (postitId, onSuccess, onError) => {
  const config = {
    method: 'post',
    url: `/postit/delete/${Number(postitId)}`,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    data: {},
  };

  axios(config)
    .then(function (response) {
      onSuccess && onSuccess(response);
    })
    .catch(function (error) {
      console.log(error);
      onError && onError(error);
    });
};

const getPublicList = (worldId, onSuccess, onError) => {
  const config = {
    method: 'get',
    url: `/postit/list-public/${Number(worldId)}`,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
  };
  axios(config)
    .then(function (response) {
      onSuccess && onSuccess(response.data);
    })
    .catch(function (error) {
      console.log(error);
      onError && onError(error.response.data);
    });
};

export const postitFetcher = {
  createPostit,
  updatePostit,
  deletePostit,
  getPublicList,
};


